// extracted by mini-css-extract-plugin
module.exports = {"title":"NetworkError_title__2gqR_"};